import { render, staticRenderFns } from "./BaseDictModal.vue?vue&type=template&id=4aa24ebb&scoped=true"
import script from "./BaseDictModal.vue?vue&type=script&lang=js"
export * from "./BaseDictModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa24ebb",
  null
  
)

export default component.exports